import * as React from 'react';
import dayjs from '../../../utils/dayjs-setup';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { GestionGeneralCompras } from './gestion-general-compras';
import { FormControl, GridLegacy as Grid, TextField } from '@mui/material';
import { DateRange } from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers';
import { ComprasPorComprador } from './compras-por-comprador';
import { GestionCasos } from './gestion-casos';
import { OrigenCompraComprador } from './origen-compra-comprador';



function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  
  export default function TabAuditoriaCompras() {
    const [value, setValue] = React.useState(0);
    const [fecha, setFecha] = React.useState(dayjs());
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
  
    return (
      <Grid container >
        <Grid item sx={12} md={12} sm={12} >
             <FormControl>
                <DatePicker 
                label='Fecha de consulta' 
                value={fecha} 
                onChange={value=>setFecha(value)} 
                slotProps={{ textField: {} }}    />
             </FormControl>
        </Grid>
        <Grid item sx={12} md={12} sm={12} >
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="Gestion general" {...a11yProps(0)} />
                <Tab label="Compras por comprador" {...a11yProps(1)} />
                <Tab label="Gestion de casos" {...a11yProps(2)} />
                <Tab label="Origen de compra" {...a11yProps(3)} />
             {/*    <Tab label="Compras por negociador" {...a11yProps(1)} /> */}
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <GestionGeneralCompras fechaSeleccionada={fecha} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <ComprasPorComprador fechaSeleccionada={fecha} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <GestionCasos fechaSeleccionada={fecha} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <OrigenCompraComprador fechaSeleccionada={fecha} />
            </CustomTabPanel>
{/*             <CustomTabPanel value={value} index={1}>
              <ComprasPorNegociador fechaSeleccionada={fecha}  />
            </CustomTabPanel> */}

          </Box>

        </Grid>
      </Grid>
    );
  }